import { render, staticRenderFns } from "./modalEditarGrupo.vue?vue&type=template&id=6b7c5250&scoped=true"
import script from "./modalEditarGrupo.vue?vue&type=script&lang=js"
export * from "./modalEditarGrupo.vue?vue&type=script&lang=js"
import style0 from "./modalEditarGrupo.vue?vue&type=style&index=0&id=6b7c5250&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7c5250",
  null
  
)

export default component.exports